import { Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { CardCopyCode } from './CardCopyCode';
import { CardTagGtm } from './CardTagGtm';
import { useState } from 'react';
import { CopyCodeContent } from './CopyCodeContent';
import { TagGtmContent } from './TagGtmContent';

export const CardCookieBannerCode = ({ id, setShowCopySuccess }) => {
  const [showCopyCode, setShowCopyCode] = useState(false);
  const [showGtm, setShowGtm] = useState(false);
  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(`
        <meta name="adopt-website-id" content="${id}" />
        <script
          src="//tag.goadopt.io/injector.js?website_code=${id}"
          class="adopt-injector"
        ></script>
        `);
      setShowCopySuccess(true);
    } catch (err) {
      console.error(err.message);
    }
  };
  return (
    <Card
      sx={{
        padding: '16px',
        marginBlockStart: '16px',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <Row>
        <Column>
          <span
            style={{
              fontSize: '20px',
              color: '#4b90fe',
            }}
          >
            Código do banner de cookies
          </span>
        </Column>
      </Row>
      <Row>
        <Column>
          <CardCopyCode setShowCopyCode={setShowCopyCode} setShowGtm={setShowGtm} showCopyCode={showCopyCode} />
        </Column>
        <Column>
          <CardTagGtm setShowCopyCode={setShowCopyCode} setShowGtm={setShowGtm} showGtm={showGtm} />
        </Column>
      </Row>
      {showCopyCode && <CopyCodeContent id={id} copyCode={copyCode} />}
      {showGtm && <TagGtmContent />}
    </Card>
  );
};
